module.exports = __webpack_public_path__ + "img/مثلث2.dedf1522.png";